import React, { useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { AuthLayout } from "@/components/AuthLayout";
import { BookingDetailsForm } from "@/components/ProfileCards";
import { useAuth, homeFor } from "@/contexts/AuthContext";
import { usePrefs } from "@/contexts/PrefsContext";

export default function CustomerWelcome() {
  const { t } = usePrefs();
  const { user } = useAuth();
  const navigate = useNavigate();
  const saving = useRef(false);
  if (!user) return null;
  if (user.role !== "customer") return <Navigate to={homeFor(user.role)} replace />;
  const done = () => {
    saving.current = true;
    const next = localStorage.getItem("wn_after_login");
    localStorage.removeItem("wn_after_login");
    navigate(next && next !== "/app/welcome" ? next : "/app", { replace: true });
  };
  if (user.booking_details_set && !saving.current) return <Navigate to="/app" replace />;
  return (
    <AuthLayout title={t("welcome.title").replace("{name}", (user.name || "").split(" ")[0])} sub={t("welcome.sub")}>
      <div data-testid="customer-welcome" className="rounded-3xl border bg-card p-5 space-y-4">
        <p className="inline-flex items-center gap-2 text-sm font-bold text-primary"><Sparkles className="h-4 w-4" />{t("welcome.step")}</p>
        <BookingDetailsForm onSaved={done} />
      </div>
    </AuthLayout>
  );
}
